import React, { useState, useEffect } from 'react';
import { FiUser, FiShoppingBag, FiMenu, FiX } from 'react-icons/fi';
import { useNavigate, Link } from 'react-router-dom';
import CarritoDropdown from './CarritoDropdown';
import '../styles/Banner.css';

const Banner: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showCarrito, setShowCarrito] = useState(false);
  const [cantidadCarrito, setCantidadCarrito] = useState(0);
  const [loggedIn, setLoggedIn] = useState(false);
  const navigate = useNavigate();

  const actualizarCantidad = () => {
    const carrito = JSON.parse(localStorage.getItem('carrito') || '[]');
    const total = carrito.reduce(
      (acc: number, item: any) => acc + (item.cantidad || 1),
      0
    );
    setCantidadCarrito(total);
  };

  useEffect(() => {
    (window as any).actualizarCantidadCarrito = actualizarCantidad;
    (window as any).abrirCarritoDropdown = () => setShowCarrito(true);
    actualizarCantidad();

    const token = localStorage.getItem('access_token');
    setLoggedIn(!!token);
  }, []);

  const handleUserClick = () => {
    const token = localStorage.getItem('access_token');
    if (token) {
      navigate('/perfil');
    } else {
      navigate('/login');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setLoggedIn(false);
    navigate('/login');
  };

  return (
    <nav className="banner">
      <div
        className="menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? <FiX className="icon" /> : <FiMenu className="icon" />}
      </div>

      <div className="logo">
        <Link to="/">ProdNook</Link>
      </div>

 <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
  {menuOpen && loggedIn ? (
    <>
      <li>
        <Link to="/perfil" className="dropdown-link" onClick={() => setMenuOpen(false)}>Perfil</Link>
      </li>
      <li>
        <Link to="/carrito" className="dropdown-link" onClick={() => setMenuOpen(false)}>Carrito</Link>
      </li>
      <li>
        <Link to="/login" onClick={() => { handleLogout(); setMenuOpen(false); }} className="dropdown-link">
          Cerrar sesión
        </Link>
      </li>
    </>
  ) : menuOpen && (
    <>
      <li>
        <Link to="/" className="dropdown-link" onClick={() => setMenuOpen(false)}>Inicio</Link>
      </li>
      <li>
        <Link to="/login" className="dropdown-link" onClick={() => setMenuOpen(false)}>Iniciar sesión</Link>
      </li>
      <li>
        <Link to="/carrito" className="dropdown-link" onClick={() => setMenuOpen(false)}>Ver carrito</Link>
      </li>
    </>
  )}
</ul>


<div className="icons">
  {loggedIn && !menuOpen && (
    <button onClick={handleLogout} className="logout-button">
      Cerrar sesión
    </button>
  )}
  <FiUser
    className="icon perfil-icon"
    title={loggedIn ? 'Ir al carrito' : 'Iniciar sesión'}
    onClick={handleUserClick}
    style={{ cursor: 'pointer' }}
  />
  <div
    className="carrito-icon-wrapper"
    onClick={() => setShowCarrito(!showCarrito)}
  >
    <FiShoppingBag className="icon" />
    {cantidadCarrito > 0 && (
      <span className="carrito-count">{cantidadCarrito}</span>
    )}
  </div>
</div>


      <CarritoDropdown visible={showCarrito} onClose={() => setShowCarrito(false)} />
    </nav>
  );
};

export default Banner;
